import React, { createRef, forwardRef } from "react";

import { createUseStyles } from "react-jss";
import { QueryBuilderComponent as SyncfusionQueryBuilderComponent } from "@syncfusion/ej2-react-querybuilder";
const QueryBuilderComponent = forwardRef((props: any, ref: any) => {
  const queryBuilderRef = ref || createRef<any>();
  const useStyles = createUseStyles({
    QueryBuilderComponent: {
      "& .e-rule-filter, & .e-rule-operator.e-operator, & .e-rule-value.e-value": {
        width: "26% !important",
        minWidth: "9.375rem",
      },
      "& .e-query-builder": {
        border: "none",
      },
      "& .e-query-builder .e-rule-container": {
        backgroundColor: "#fff",
      },
    },
  });

  const classes = useStyles() as any;

  return (
    <div className={classes.QueryBuilderComponent} id="QueryBuilderComponentWrapper">
      <SyncfusionQueryBuilderComponent {...props} className={classes.QueryBuilderComponent} ref={queryBuilderRef}>
        {props.children}
      </SyncfusionQueryBuilderComponent>
    </div>
  );
});
QueryBuilderComponent.displayName = "QueryBuilderComponent";
export default QueryBuilderComponent;
